import React from 'react';

const TextArea = ({
  label,
  labelHint,
  className,
  hint,
  error,
  size = 'md',
  disabled,
  required,
  value = '',
  rows = 4,
  ...props
}) => {
  const sizeClasses = {
    xs: 'px-2 py-1 text-xs',
    sm: 'px-2 py-1 text-sm',
    md: 'px-2.5 py-1.5 text-sm',
    lg: 'px-3 py-2 text-sm',
    xl: 'px-3.5 py-2.5 text-sm'
  };

  return (
    <div className='w-full'>
      <div className='flex justify-between'>
        <label className='block text-sm font-medium leading-6 text-base-900'>
          {label}
          {required && <span className='text-danger-700 ml-1'>*</span>}
        </label>
        {labelHint && (
          <span className='text-sm leading-6 text-base-500'>{labelHint}</span>
        )}
      </div>
      <div className='mt-2'>
        <textarea
          disabled={disabled}
          rows={rows}
          className={`block w-full min-w-0 border-0 text-base-900 disabled:text-base-500 ring-1 ring-inset ${
            error
              ? 'ring-danger-300 focus:ring-danger-600'
              : 'ring-base-300 focus:ring-primary-600'
          } placeholder:text-base-400 focus:ring-2 focus:ring-inset rounded-md ${
            sizeClasses[size]
          } sm:leading-6 ${
            disabled ? ' cursor-not-allowed text-base-500' : ''
          } ${className ? ` ${className}` : ''}`}
          value={value}
          {...props}
        />
      </div>
      {error ? (
        <p className='mt-1 text-sm text-danger-600'>{error}</p>
      ) : (
        hint && <p className='mt-1 text-sm text-base-500'>{hint}</p>
      )}
    </div>
  );
};

export { TextArea };
